import i18nIsoCountries from 'i18n-iso-countries';
import DE from 'i18n-iso-countries/langs/de.json' with { type: 'json' };
import EN from 'i18n-iso-countries/langs/en.json' with { type: 'json' };

i18nIsoCountries.registerLocale(DE);
i18nIsoCountries.registerLocale(EN);

export { default as countryNames } from 'i18n-iso-countries';

/** ISO 3166-1 alpha-2 codes that country pickers list first, in this order. */
export const PRIORITIZED_COUNTRY_CODES = ['DE', 'AT', 'CH'] as const;

const PRIORITIZED_COUNTRY_RANK = new Map<string, number>(
  PRIORITIZED_COUNTRY_CODES.map((code, index) => [code, index]),
);

/**
 * Moves the prioritized countries (DE, AT, CH) to the front and keeps every
 * other item in its given order.
 *
 * @param items - The countries, in the order the rest should keep.
 * @param getCountryCode - Reads an item's ISO 3166-1 alpha-2 code.
 */
export function prioritizeCountries<T>(
  items: readonly T[],
  getCountryCode: (item: T) => string,
): T[] {
  const rank = (item: T) =>
    PRIORITIZED_COUNTRY_RANK.get(getCountryCode(item)) ??
    PRIORITIZED_COUNTRY_CODES.length;

  return items.toSorted((a, b) => rank(a) - rank(b));
}
